import React, { Component } from "react";
import { Spin, Modal } from "antd";
import { broadcastWebUpgrade, broadcastRelogin } from "../../services";
import DeploymentView from "./DeploymentView";
import { showSuccessNotification, showErrorNotification } from "../../helpers";

export default class DeploymentContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessing: false,
      selectedApp: "auth"
    };
  }

  /**
   * @function handleAppSelect
   * @param value
   * @desc this will handle selecting app type from dropdown
   */
  handleAppSelect = value => {
    this.setState({ selectedApp: value });
  };

  /**
   * @function broadcastNotification
   * @desc this will handle sending deployment notification to selected app
   */
  broadcastNotification = () => {
    const { selectedApp } = this.state;
    const params = {
      app_type: selectedApp
    };
    this.setState({ isProcessing: true });
    broadcastWebUpgrade(params)
      .then(res => {
        this.setState({ isProcessing: false });
        if (res && res.data && res.data.success) {
          showSuccessNotification("Web Upgrade notification sent successfully");
        } else {
          showErrorNotification("Something went wrong. Plesae try again");
        }
      })
      .catch(() => {
        showErrorNotification("Something went wrong. Plesae try again");
        this.setState({ isProcessing: false });
      });
  };

  /**
   * @function broadcastReloginNotification
   * @desc this will handle sending relogin notification to all the users
   */
  broadcastReloginNotification = () => {
    this.setState({ isProcessing: true });
    broadcastRelogin()
      .then(res => {
        this.setState({ isProcessing: false });
        if (res && res.data && res.data.success) {
          showSuccessNotification("Relogin notification sent successfully");
        } else {
          showErrorNotification("Something went wrong. Plesae try again");
        }
      })
      .catch(() => {
        showErrorNotification("Something went wrong. Plesae try again");
        this.setState({ isProcessing: false });
      });
  };

  render() {
    const { isProcessing, selectedApp } = this.state;

    return (
      <Spin spinning={isProcessing}>
        <DeploymentView
          handleAppSelect={this.handleAppSelect}
          selectedApp={selectedApp}
          broadcastNotification={this.broadcastNotification}
          broadcastReloginNotification={this.broadcastReloginNotification}
        />
      </Spin>
    );
  }
}
